import { HyruleToken } from '@nintendo/hyrule-react-commons';
import { GameRecommendationApiModel } from './models';
import { BaseApi } from './BaseApi';

export class GameRecommendationsApi {
    static async getGameRecommendations(
        naid: string,
        hyruleToken: HyruleToken,
        correlationId: string,
    ): Promise<GameRecommendationApiModel> {
        const { accountApiUrls } = BaseApi.ApiConfig();
        const url: string = accountApiUrls.gameRecommendations(naid);
        const init: RequestInit = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${hyruleToken.accessToken}`,
                'x-correlation-id': correlationId,
            },
        };

        try {
            const response: Response = await fetch(url, init);
            let model: GameRecommendationApiModel = { data: [] };

            // If we're able to parse valid JSON from the response, do it.
            // Otherwise, if it's something like an HTTP 204 No Content and
            // it throws an error, then catch it and just set the array empty.
            await response
                .json()
                .then((json) => {
                    model = json || { data: [] };
                })
                .catch(() => {
                    model = { data: [] };
                });

            return model;
        } catch (error) {
            console.log(`Error: ${error}`);
            throw error;
        }
    }

    static mapToGameRecommendationEntries(model: GameRecommendationApiModel): string[] {
        return model.data[0]?.items || [];
    }
}
